import React, { FC, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import moment from 'moment';

import "./transition-payout-detail.scss";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { payoutTransactionsActions, fetchMerchantPayoutTransactions } from "../../../../reducers/payoutTransactionsSlice";
import { MerchantBookedTeesheets } from "../../../../models/merchantBookedTeesheets";
import { useTranslation } from "react-i18next";

interface TransitionPayoutDetailProps {}

const TransitionPayoutDetail: FC<TransitionPayoutDetailProps> = () => {

  const { id }: any = useParams();
  const dispatch = useAppDispatch();
  const payoutTransactions: Array<MerchantBookedTeesheets> = useAppSelector(fetchMerchantPayoutTransactions) || [];
  
  useEffect(() => {
    if (id) {
      dispatch(payoutTransactionsActions.payoutTransactionsList({payoutId: id}));
    }
  }, []);

  const {t}=useTranslation("")

  const toNumber = (v: any) => {
    const n = Number(v ?? 0);
    return Number.isFinite(n) ? n : 0;
  };

  const formatCad = (amount: any) =>
    `$ ${toNumber(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const getRate = (obj: any) => {
    const rate = Number(obj?.payoutConversion?.exchangeRate ?? 0);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  };

  const toCad = (amount: any, obj: any) => {
    const n = toNumber(amount);
    const isUsd = String(obj?.payoutCurrency || "").toUpperCase() === "USD";
    return isUsd ? n * getRate(obj) : n;
  };

  const groupedByBooking = Object.values(
    payoutTransactions.reduce<Record<string, MerchantBookedTeesheets[]>>((acc, item) => {
      const key = String(item?.booking?._id ?? item?.booking?.bookingId ?? item?._id ?? "");
      if (!key || key === "undefined" || key === "null") return acc;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {})
  );
  
  return (
    <div className="transition-payout-detail">
      <div className="commonHeader transitionWrapper__header pb-4">
        <div className="container">
          <div className="row gutters-10 align-items-center mb-4 pb-2">
            <div className="col-auto">
              <NavLink
                to={"/transaction/payout"}
                className="button button-s3 button-border button-pill button-sm px-4 color-white"
              >
                <em className="fas fa-arrow-left me-2"></em> {t("transactionDetailModal.backButton")}
              </NavLink>
            </div>
            <div className="col-auto">
              <ul className="navBreadCrumb">
                <li>
                  <span>{t("transactionDetailModal.PayoutDetails")}</span>
                </li>
              </ul>
            </div>
          </div>
  
          {/*
          Summary cards hidden — same figures are shown in the booking table below.
          <div className="row gutters-10 align-items-center">
            <div className="col">
              <div className="row gutters-10">
                <div className="col-auto">
                  <div className="_tBlock _tBlock--sm mb-2">
                    <label className="mr-2 mb-4 d-block">Total Teesheet Price (CAD)</label>
                    <h5 className="mb-0">{ toNumber(activePayout?.total_amount) > 0 ? formatCad(toCad(activePayout?.total_amount, activePayout)) : '$ 0.00' }</h5>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="_tBlock _tBlock--sm mb-2">
                    <label className="mr-2 mb-4 d-block">Total Products Price (CAD)</label>
                    <h5 className="mb-0">{ toNumber(activePayout?.total_product_amount) > 0 ? formatCad(toCad(activePayout?.total_product_amount, activePayout)) : '$ 0.00' }</h5>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="_tBlock _tBlock--sm mb-2">
                    <label className="mr-2 mb-4 d-block">Integolf Fees (CAD)</label>
                    <h5 className="mb-0">{ toNumber(activePayout?.fees) > 0 ? `- ${formatCad(toCad(activePayout?.fees, activePayout))}`: '$ 0.00' }</h5>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="_tBlock _tBlock--sm mb-2">
                    <label className="mr-2 mb-4 d-block">Product Fees (CAD)</label>
                    <h5 className="mb-0">{ toNumber(activePayout?.product_fees) > 0 ? `- ${formatCad(toCad(activePayout?.product_fees, activePayout))}`: '$ 0.00' }</h5>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="_tBlock _tBlock--sm mb-2">
                    <label className="mr-2 mb-4 d-block">Golf Payout (CAD)</label>
                    <h5 className="mb-0">{toNumber(activePayout?.payout_amount) > 0 ? formatCad(toCad(activePayout?.payout_amount, activePayout)) : '$ 0.00'}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          */}
        </div>
      </div>
      <div className="transitionWrapper__body">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-border">
                  <thead>
                    <tr>
                      {/* <th>{t("transactionDetailModal.tableHeadings.PaidBy")}</th> */}
                      <th>{t("transactionDetailModal.tableHeadings.BookingID")}</th>
                      <th>
                      {t("transactionDetailModal.tableHeadings.Date")} 
                        {/* <em className="fa-solid fa-sort ms-1 color-700"></em> */}
                      </th>
                      <th>Teesheet Price (CAD)</th>
                      <th>Products Price (CAD)</th>
                      <th>Integolf Fees (CAD)</th>
                      <th>Product Fees (CAD)</th>




                     
                      
                      
              
                      {/* <th>Booking Fee</th> */}
                      <th>
                      Golf Payout (CAD){" "}
                        {/* <em className="fa-solid fa-sort ms-1 color-700"></em> */}
                      </th>
                    </tr>
                  </thead>
                  {
                    groupedByBooking && groupedByBooking.length ? 
                      <tbody>
                        {groupedByBooking.map((bookingItems) => {
                          const first = bookingItems?.[0];
                          const userName = first?.firstname && (first?.firstname.length || first?.lastname?.length)
                            ? `${first?.firstname} ${first?.lastname}`
                            : '-';
                          const bookingId = first?.booking?.bookingId || "-";
                          const bookingDetailId = first?.booking?._id;
                          const createdAt = first?.createdAt;
                          const teesheetPrice = bookingItems.reduce((sum, item) => sum + toCad(item?.totalAmount, item), 0);
                          const productsPrice = bookingItems.reduce((sum, item) => sum + toCad(item?.productsTotalPrice, item), 0);
                          const integolfFees = bookingItems.reduce((sum, item) => sum + toCad(item?.integolfFees, item), 0);
                          const productFees = bookingItems.reduce((sum, item) => sum + toCad(item?.productFee, item), 0);
                          const amountTransferred = bookingItems.reduce(
                            (sum, item) => sum + toCad(item?.payouts?.merchantPayoutAmount, item),
                            0
                          );

                          return (
                            <tr key={String(first?._id ?? bookingId)}>
                              {/* <td>
                                <h6 className="mb-0 fw700">{userName}</h6>
                              </td> */}
                              <td>
                                {bookingDetailId ? (
                                  <NavLink to={`/booking-detail/${bookingDetailId}`} className="text-decoration-none">
                                    <span className="fw400" style={{ color: "#00D19F" }}>{bookingId}</span>
                                  </NavLink>
                                ) : (
                                  <span className="color-600 fw400">{bookingId}</span>
                                )}
                              </td>
                              <td>{createdAt ? moment(createdAt).format("dddd, DD MMM YYYY") : '-'}</td>
                              <td>
                                <h6 className="mb-0 fw700">{teesheetPrice ? formatCad(teesheetPrice) : '$ 0.00'}</h6>
                              </td>
                              <td>
                                <h6 className="mb-0 fw700">{productsPrice > 0 ? formatCad(productsPrice) : "N/A"}</h6>
                              </td>
                              <td>
                                <span className="color-600 fw500">{integolfFees ? `- ${formatCad(integolfFees)}` : '$ 0.00'}</span>
                              </td>
                              <td>
                                <span className="color-600 fw500">{productFees > 0 ? `- ${formatCad(productFees)}` : "N/A"}</span>
                              </td>
                              <td>
                                <h6 className="mb-0 fw700">{amountTransferred ? formatCad(amountTransferred) : '$ 0.00'}</h6>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody> :
                      <div className='bookingsListWrapper' id='transactionsListWrapper'>
                        <div className="noBookingBlock text-center mt-4 py-5">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/images/no-booking.png`}
                          alt="no-booking"
                          className="img-fluid mx-auto d-block"
                        />
                        <h5 className="mt-4 pt-3 fontsize-16 fw600">
                        {t("transactionDetailModal.NoPayoutsListMessage")}
                        </h5>
                        </div>
                      </div> 
                  }
                  <tbody>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}

export default TransitionPayoutDetail;
